import "../../styles/all.css";
import "../../styles/theme.css";
import "./report.css";
import Progress from "../progress/progress"
import Marketing from "../marketing/marketing"
function Salesreport(){
    return(
        <>
        <div className="sales">
            <div className="cards">
               <div className="row g-3">
  <div className="col-md-4">
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">
          <i className="fa-solid fa-dollar-sign text-success me-2"></i>
          Active Deals
        </h5>
        <p className="fs-4 fw-bold">5,658 USD</p>
        <p className="text-success">▲ VS Last Month</p>
             <p className="card-text ">
        Some quick example text to build on the card title and make up the bulk of the card’s content.
      </p>
      </div>
    </div>
  </div>
  <div className="col-md-4">
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">
          <i className="fa-solid fa-users text-primary me-2"></i>
          New Clients
        </h5>
        <p className="fs-4 fw-bold">1,245</p>
        <p className="text-success">▲ +12%</p>
             <p className="card-text ">
        Some quick example text to build on the card title and make up the bulk of the card’s content.
      </p>
      </div>
    </div>
  </div>
  <div className="col-md-4">
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">
          <i className="fa-solid fa-chart-line text-warning me-2"></i>
          Revenue
        </h5>
        <p className="fs-4 fw-bold">$32,800</p>
        <p className="text-danger">▼ -5%</p>
             <p className="card-text ">
        Some quick example text to build on the card title and make up the bulk of the card’s content.
      </p>
      </div>
    </div>
  </div>
  <div className="col-md-4">
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">
          <i className="fa-solid fa-cart-shopping text-info me-2"></i>
          Orders
        </h5>
        <p className="fs-4 fw-bold">842</p>
        <p className="text-success">▲ +8%</p>
             <p className="card-text ">
        Some quick example text to build on the card title and make up the bulk of the card’s content.
      </p>
      </div>
    </div>
  </div>
  <div className="col-md-4">
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">
          <i className="fa-solid fa-box text-secondary me-2"></i>
          Products
        </h5>
        <p className="fs-4 fw-bold">320</p>
        <p className="text-muted">Total Products</p>
             <p className="card-text ">
        Some quick example text to build on the card title and make up the bulk of the card’s content.
      </p>
      </div>
    </div>
  </div>
  <div className="col-md-4">
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">
          <i className="fa-solid fa-star text-warning me-2"></i>
          Reviews
        </h5>
        <p className="fs-4 fw-bold">4.8</p>
        <p className="text-muted">Avg Rating</p>
          <p className="card-text ">
        Some quick example text to build on the card title and make up the bulk of the card’s content.
      </p>
      </div>
    </div>
  </div>

</div>


            </div>

        </div>
        <Progress/>
        <Marketing/>
        </>
    )
}
export default Salesreport